import WorkReport from "@/components/Reports/WorkReport.vue";
import WordReportHeader from "@/components/Reports/WordReportHeader.vue";

export default [
    {
        path: 'reports/work',
        name: 'WorkReport',
        components: {
            page: WorkReport,
            header: WordReportHeader
        },
        meta: {
            requiresAuth: true
        }
    }
];
